const countries = [
  {
    countries: [
      {
        name: "Bangladesh",
        alpha2Code: "BD",
        alpha3Code: "BGD",
        currencyCode: "BDT",
        states: [
          {
            name: "Dhaka",
            districts: [
              "Dhaka",
              "Gazipur",
              "Tangail",
              "Kishoreganj",
              "Manikganj",
              "Munshiganj",
              "Narayanganj",
              "Narsingdi",
              "Rajbari",
              "Faridpur",
              "Madaripur",
              "Gopalganj",
              "Shariatpur",
            ],
          },
          {
            name: "Chattogram",
            districts: [
              "Chattogram",
              "Cox's Bazar",
              "Rangamati",
              "Khagrachari",
              "Bandarban",
              "Noakhali",
              "Feni",
              "Lakshmipur",
              "Cumilla",
              "Brahmanbaria",
              "Chandpur",
            ],
          },
          {
            name: "Khulna",
            districts: [
              "Khulna",
              "Jashore",
              "Satkhira",
              "Bagerhat",
              "Narail",
              "Magura",
              "Jhenaidah",
              "Chuadanga",
              "Kushtia",
              "Meherpur",
            ],
          },
          {
            name: "Rajshahi",
            districts: [
              "Rajshahi",
              "Bogura",
              "Pabna",
              "Naogaon",
              "Natore",
              "Joypurhat",
              "Chapainawabganj",
              "Sirajganj",
            ],
          },
          {
            name: "Barishal",
            districts: [
              "Barishal",
              "Bhola",
              "Jhalokathi",
              "Patuakhali",
              "Barguna",
              "Pirojpur",
            ],
          },
          {
            name: "Sylhet",
            districts: ["Sylhet", "Moulvibazar", "Habiganj", "Sunamganj"],
          },
          {
            name: "Rangpur",
            districts: [
              "Rangpur",
              "Dinajpur",
              "Kurigram",
              "Thakurgaon",
              "Nilphamari",
              "Panchagarh",
              "Gaibandha",
              "Lalmonirhat",
            ],
          },
          {
            name: "Mymensingh",
            districts: ["Mymensingh", "Jamalpur", "Sherpur", "Netrokona"],
          },
        ],
      },
      {
        name: "Saudi Arabia",
        alpha2Code: "SA",
        alpha3Code: "SAU",
        currencyCode: "SAR",
        states: [{ name: "Saudi Arabia" }],
        districts: [{ name: "Saudi Arabia" }],
      },
      {
        name: "United Arab Emirates",
        alpha2Code: "AE",
        alpha3Code: "ARE",
        currencyCode: "AED",
        states: [{ name: "United Arab Emirates" }],
        districts: [{ name: "United Arab Emirates" }],
      },
      {
        name: "Malaysia",
        alpha2Code: "MY",
        alpha3Code: "MYS",
        currencyCode: "MYR",
        states: [{ name: "Malaysia" }],
        districts: [{ name: "Malaysia" }],
      },
      {
        name: "India",
        alpha2Code: "IN",
        alpha3Code: "IND",
        currencyCode: "INR",
        states: [{ name: "India" }],
        districts: [{ name: "India" }],
      },
      {
        name: "Nepal",
        alpha2Code: "NP",
        alpha3Code: "NPL",
        currencyCode: "NPR",
        states: [{ name: "Nepal" }],
        districts: [{ name: "Nepal" }],
      },
      {
        name: "Thailand",
        alpha2Code: "TH",
        alpha3Code: "THA",
        currencyCode: "THB",
        states: [{ name: "Thailand" }],
        districts: [{ name: "Thailand" }],
      },
      {
        name: "Singapore",
        alpha2Code: "SG",
        alpha3Code: "SGP",
        currencyCode: "SGD",
        states: [{ name: "Singapore" }],
        districts: [{ name: "Singapore" }],
      },
      {
        name: "China",
        alpha2Code: "CN",
        alpha3Code: "CHN",
        currencyCode: "CNY",
        states: [{ name: "China" }],
        districts: [{ name: "China" }],
      },
      {
        name: "Kuwait",
        alpha2Code: "KW",
        alpha3Code: "KWT",
        currencyCode: "KWD",
        states: [{ name: "Kuwait" }],
        districts: [{ name: "Kuwait" }],
      },
      {
        name: "Qatar",
        alpha2Code: "QA",
        alpha3Code: "QAT",
        currencyCode: "QAR",
        states: [{ name: "Qatar" }],
        districts: [{ name: "Qatar" }],
      },
      {
        name: "Oman",
        alpha2Code: "OM",
        alpha3Code: "OMN",
        currencyCode: "OMR",
        states: [{ name: "Oman" }],
        districts: [{ name: "Oman" }],
      },
      {
        name: "Germany",
        alpha2Code: "DE",
        alpha3Code: "DEU",
        currencyCode: "EUR",
        states: [{ name: "Germany" }],
        districts: [{ name: "Germany" }],
      },
      {
        name: "United States",
        alpha2Code: "US",
        alpha3Code: "USA",
        currencyCode: "USD",
        states: [{ name: "United States" }],
        districts: [{ name: "United States" }],
      },
      {
        name: "United Kingdom",
        alpha2Code: "UK",
        alpha3Code: "GBR",
        currencyCode: "GBP",
        states: [{ name: "United Kingdom" }],
        districts: [{ name: "United Kingdom" }],
      },
    ],
  },
];

export default countries;
